import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap";

function useFonts() {
  useEffect(() => {
    if (document.querySelector('link[href*="Instrument+Serif"]')) return;
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = FONTS_URL;
    document.head.appendChild(l);
  }, []);
}

const T = {
  g700: "#155c36", g600: "#1b7a47", g500: "#1e9254", g400: "#28b566",
  g200: "#a7d9bc", g100: "#d6f0e3", g50: "#eef8f3",
  n900: "#0f1117", n800: "#1c2130", n700: "#2d3549", n600: "#4a5268",
  n400: "#8a93a8", n300: "#b0b8cc", n200: "#d1d5e0", n150: "#e4e7ef",
  n100: "#eef0f5", n50: "#f7f8fa", white: "#ffffff",
  amber: "#d97706", amberBg: "#fffbeb", amberBorder: "#fde68a",
  serif: "'Instrument Serif', Georgia, serif",
  sans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
};

const Icon = ({ name, size = 20, color = "currentColor", strokeWidth = 1.6 }) => {
  const paths = {
    ArrowLeft:    <><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></>,
    ArrowRight:   <><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></>,
    CheckCircle:  <><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></>,
    Mail:         <><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></>,
    Phone:        <><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.5a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.34 3h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 10.09a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></>,
    Clock:        <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
    Users:        <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>,
    Home:         <><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>,
    Briefcase:    <><rect width="20" height="14" x="2" y="7" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></>,
    Wrench:       <><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></>,
    MessageCircle:<><path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z"/></>,
    Send:         <><path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/></>,
    ChevronDown:  <><path d="m6 9 6 6 6-6"/></>,
    ShieldCheck:  <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></>,
    Zap:          <><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></>,
    Star:         <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>,
    MapPin:       <><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></>,
    BadgeCheck:   <><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></>,
    Wallet:       <><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/><path d="M18 12a2 2 0 0 0 0 4h4v-4Z"/></>,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      {paths[name]}
    </svg>
  );
};

/* ══ DATA ══ */

const AUDIENCE_OPTIONS = [
  {
    id: "homeowner",
    icon: "Home",
    label: "I need a home service",
    sub: "Homeowner or tenant looking to book a professional",
    color: T.g500,
    colorBg: T.g50,
    colorBorder: T.g100,
  },
  {
    id: "business",
    icon: "Briefcase",
    label: "I represent a business",
    sub: "Corporate, agency, property manager, or insurer",
    color: "#2563eb",
    colorBg: "#eff6ff",
    colorBorder: "#bfdbfe",
  },
  {
    id: "pro",
    icon: "Wrench",
    label: "I want to offer services",
    sub: "Professional looking to join JiraniApp as a JiraniPro",
    color: T.amber,
    colorBg: T.amberBg,
    colorBorder: T.amberBorder,
  },
];

const CONTACT_CHANNELS = [
  {
    icon: "Mail",
    label: "Email us",
    value: "sales@jiraniapp.com",
    sub: "We respond within one business day",
    href: "mailto:sales@jiraniapp.com",
  },
  {
    icon: "Phone",
    label: "Call us",
    value: "+254 700 000 000",
    sub: "Monday to Friday, 8am to 6pm EAT",
    href: "tel:+254700000000",
  },
  {
    icon: "MessageCircle",
    label: "Live chat",
    value: "Available in the app",
    sub: "Tap the chat icon once you are signed in",
    href: null,
  },
];

const HOMEOWNER_REASONS = [
  { icon: "BadgeCheck", text: "Every professional is ID-verified before going live" },
  { icon: "Wallet",    text: "Pay securely via M-Pesa, released only on completion" },
  { icon: "Star",      text: "Real reviews from real, verified bookings only" },
  { icon: "MapPin",    text: "Local professionals in your exact neighbourhood" },
  { icon: "Clock",     text: "Book same-day or schedule ahead, fully on your terms" },
  { icon: "ShieldCheck", text: "Jirani Guarantee backs every booking on the platform" },
];

const BUSINESS_REASONS = [
  { icon: "Briefcase",  text: "Dedicated account manager from day one" },
  { icon: "Zap",        text: "Live within two weeks of signing" },
  { icon: "Users",      text: "700+ verified professionals across Kenya" },
  { icon: "MapPin",     text: "Coverage across Nairobi, Mombasa, Kisumu and more" },
  { icon: "Wallet",     text: "Monthly invoice billing and structured reporting" },
  { icon: "ShieldCheck", text: "Set minimum rating requirements for your account" },
];

const PRO_REASONS = [
  { icon: "Zap",        text: "Consistent bookings, not just occasional one-offs" },
  { icon: "Wallet",     text: "M-Pesa payout within 24 hours of job completion" },
  { icon: "BadgeCheck", text: "Verified badge builds client trust and drives bookings" },
  { icon: "Clock",      text: "You set your own hours and service areas" },
  { icon: "Star",       text: "Build a public reputation that compounds over time" },
  { icon: "Users",      text: "Join a growing community of Kenya's best home Pros" },
];

const AUDIENCE_CONTEXT = {
  homeowner: {
    formTitle: "Tell us what you need",
    formSub: "Describe the service and we will help you find the right professional.",
    ctaLabel: "Or browse professionals directly",
    ctaPath: "/search",
    reasons: HOMEOWNER_REASONS,
    reasonsTitle: "Why clients choose JiraniApp",
    messagePlaceholder: "What service do you need, where are you based, and when are you looking to book?",
  },
  business: {
    formTitle: "Let us understand your needs",
    formSub: "Tell us about your organisation and what you are trying to solve. Our sales team will be in touch within one business day.",
    ctaLabel: "Or read about partnership options",
    ctaPath: "/partner",
    reasons: BUSINESS_REASONS,
    reasonsTitle: "Why businesses work with JiraniApp",
    messagePlaceholder: "Tell us about your organisation, the number of properties or employees involved, and what you are looking to achieve.",
  },
  pro: {
    formTitle: "Ready to start earning?",
    formSub: "Share your details and someone from our Pro onboarding team will guide you through the next steps.",
    ctaLabel: "Or apply directly as a JiraniPro",
    ctaPath: "/become-a-pro",
    reasons: PRO_REASONS,
    reasonsTitle: "Why Pros join JiraniApp",
    messagePlaceholder: "What services do you offer, how many years of experience do you have, and which city or area do you work in?",
  },
};

/* ── Sub-components ── */

function ContactChannel({ icon, label, value, sub, href }) {
  const inner = (
    <div style={{
      padding: "20px 22px", borderRadius: 14,
      border: `1px solid ${T.n150}`, background: T.white,
      display: "flex", gap: 14, alignItems: "flex-start",
      transition: "border-color .15s, background .15s",
    }}
      onMouseEnter={e => { if (href) { e.currentTarget.style.borderColor = T.g200; e.currentTarget.style.background = T.g50; }}}
      onMouseLeave={e => { e.currentTarget.style.borderColor = T.n150; e.currentTarget.style.background = T.white; }}>
      <div style={{
        width: 40, height: 40, borderRadius: 11, flexShrink: 0,
        background: T.n50, border: `1px solid ${T.n150}`,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <Icon name={icon} size={17} color={T.g500} strokeWidth={1.6} />
      </div>
      <div>
        <div style={{ fontSize: 12, fontWeight: 600, color: T.n400, letterSpacing: "0.04em", textTransform: "uppercase", marginBottom: 3 }}>{label}</div>
        <div style={{ fontSize: 15, fontWeight: 600, color: T.n900, marginBottom: 3, letterSpacing: "-0.01em" }}>{value}</div>
        <div style={{ fontSize: 12, color: T.n400, lineHeight: 1.4 }}>{sub}</div>
      </div>
    </div>
  );
  if (href) {
    return <a href={href} style={{ textDecoration: "none", display: "block" }}>{inner}</a>;
  }
  return inner;
}

function ReasonItem({ icon, text }) {
  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
      <span style={{ flexShrink: 0, marginTop: 1 }}>
        <Icon name={icon} size={15} color={T.g500} strokeWidth={2} />
      </span>
      <span style={{ fontSize: 14, color: T.n700, lineHeight: 1.6 }}>{text}</span>
    </div>
  );
}

/* ── Main form ── */
function SalesForm({ audience }) {
  const ctx = AUDIENCE_CONTEXT[audience];
  const navigate = useNavigate();

  const [form, setForm] = useState({ name: "", contact: "", org: "", message: "" });
  const [focused, setFocused] = useState("");
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    setForm({ name: "", contact: "", org: "", message: "" });
    setSubmitted(false);
  }, [audience]);

  const inputStyle = (field) => ({
    width: "100%", padding: "13px 16px",
    border: `1px solid ${focused === field ? T.g500 : T.n200}`,
    borderRadius: 10, fontSize: 14, outline: "none",
    background: T.white, color: T.n900, fontFamily: T.sans,
    boxShadow: focused === field ? `0 0 0 4px ${T.g100}` : "none",
    transition: "all .18s",
  });

  const labelStyle = {
    display: "block", fontSize: 13, fontWeight: 600,
    color: T.n700, marginBottom: 6, letterSpacing: "-0.01em",
  };

  if (submitted) {
    return (
      <div style={{
        padding: "52px 32px", textAlign: "center",
        border: `1.5px solid ${T.g200}`, borderRadius: 20,
        background: T.g50,
      }}>
        <div style={{
          width: 56, height: 56, borderRadius: "50%",
          background: T.g500, display: "flex",
          alignItems: "center", justifyContent: "center", margin: "0 auto 20px",
        }}>
          <Icon name="CheckCircle" size={26} color={T.white} strokeWidth={2} />
        </div>
        <h3 style={{ fontFamily: T.serif, fontSize: 26, fontWeight: 400, color: T.n900, margin: "0 0 10px", letterSpacing: "-0.02em" }}>
          {audience === "homeowner" ? "We got your request" : audience === "pro" ? "Application received" : "Message received"}
        </h3>
        <p style={{ fontSize: 15, color: T.n600, lineHeight: 1.8, margin: "0 auto 28px", maxWidth: 380 }}>
          {audience === "homeowner"
            ? "Someone from our team will be in touch shortly to help you find the right professional for your job."
            : audience === "pro"
            ? "Our Pro onboarding team will reach out within one business day to walk you through next steps."
            : "Our sales team will be in touch within one business day. We look forward to the conversation."}
        </p>
        <button onClick={() => setSubmitted(false)} style={{
          padding: "11px 24px", background: "transparent", color: T.n700,
          border: `1.5px solid ${T.n200}`, borderRadius: 10, fontSize: 14,
          fontWeight: 600, fontFamily: T.sans, cursor: "pointer",
        }}
          onMouseEnter={e => e.currentTarget.style.borderColor = T.n400}
          onMouseLeave={e => e.currentTarget.style.borderColor = T.n200}>
          Send another message
        </button>
      </div>
    );
  }

  return (
    <div style={{ border: `1px solid ${T.n150}`, borderRadius: 20, padding: "clamp(28px,5vw,40px)", background: T.white }}>
      <div style={{ marginBottom: 28 }}>
        <h3 style={{ fontFamily: T.serif, fontSize: "clamp(22px,3.5vw,28px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
          {ctx.formTitle}
        </h3>
        <p style={{ fontSize: 14, color: T.n400, margin: 0, lineHeight: 1.7 }}>{ctx.formSub}</p>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 14 }}>
          <div>
            <label style={labelStyle}>Your name</label>
            <input
              value={form.name}
              onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
              onFocus={() => setFocused("name")} onBlur={() => setFocused("")}
              placeholder="Full name"
              style={inputStyle("name")} />
          </div>
          <div>
            <label style={labelStyle}>
              {audience === "homeowner" ? "Phone or email" : "Work email"}
            </label>
            <input
              value={form.contact}
              onChange={e => setForm(f => ({ ...f, contact: e.target.value }))}
              onFocus={() => setFocused("contact")} onBlur={() => setFocused("")}
              placeholder={audience === "homeowner" ? "+254 7XX XXX XXX or email" : "your@company.com"}
              style={inputStyle("contact")} />
          </div>
        </div>

        {audience !== "homeowner" && (
          <div>
            <label style={labelStyle}>
              {audience === "pro" ? "Your trade or service" : "Organisation name"}
            </label>
            <input
              value={form.org}
              onChange={e => setForm(f => ({ ...f, org: e.target.value }))}
              onFocus={() => setFocused("org")} onBlur={() => setFocused("")}
              placeholder={audience === "pro" ? "e.g. Electrician, Plumber, Cleaner" : "Company or organisation name"}
              style={inputStyle("org")} />
          </div>
        )}

        <div>
          <label style={labelStyle}>
            {audience === "homeowner" ? "What do you need?" : "Tell us more"}
          </label>
          <textarea
            value={form.message}
            onChange={e => setForm(f => ({ ...f, message: e.target.value }))}
            onFocus={() => setFocused("msg")} onBlur={() => setFocused("")}
            placeholder={ctx.messagePlaceholder}
            rows={4}
            style={{ ...inputStyle("msg"), resize: "vertical", lineHeight: 1.65 }} />
        </div>

        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
          <button
            onClick={() => { if (!form.name || !form.contact) return; setSubmitted(true); }}
            style={{
              padding: "13px 28px", background: T.g500, color: T.white,
              border: "none", borderRadius: 10, fontSize: 14, fontWeight: 600,
              fontFamily: T.sans, cursor: "pointer", letterSpacing: "0.01em",
              display: "inline-flex", alignItems: "center", gap: 8, transition: "background .18s",
            }}
            onMouseEnter={e => e.currentTarget.style.background = T.g600}
            onMouseLeave={e => e.currentTarget.style.background = T.g500}>
            {audience === "homeowner" ? "Send my request" : audience === "pro" ? "Send my application" : "Send message"}
            <Icon name="Send" size={14} color={T.white} strokeWidth={2} />
          </button>
          <button
            onClick={() => navigate(ctx.ctaPath)}
            style={{
              padding: "13px 20px", background: "transparent", color: T.n600,
              border: `1.5px solid ${T.n200}`, borderRadius: 10, fontSize: 13,
              fontWeight: 500, fontFamily: T.sans, cursor: "pointer",
              display: "inline-flex", alignItems: "center", gap: 6,
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = T.n400; e.currentTarget.style.color = T.n900; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = T.n200; e.currentTarget.style.color = T.n600; }}>
            {ctx.ctaLabel}
            <Icon name="ArrowRight" size={13} color="currentColor" strokeWidth={2} />
          </button>
        </div>

        <p style={{ fontSize: 12, color: T.n300, margin: 0 }}>
          We do not share your details with third parties or add you to mailing lists without consent.
        </p>
      </div>
    </div>
  );
}

/* ══ MAIN PAGE ══ */
export default function ContactSalesPage() {
  useFonts();
  const navigate = useNavigate();
  const [audience, setAudience] = useState("homeowner");

  const ctx = AUDIENCE_CONTEXT[audience];
  const selected = AUDIENCE_OPTIONS.find(a => a.id === audience);

  return (
    <div style={{ fontFamily: T.sans, background: T.white, minHeight: "100vh", color: T.n900, paddingBottom: 80 }}>
      <style>{`
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { display: none; }
      `}</style>

      {/* ── Nav ── */}
      <div style={{ padding: "16px 24px", borderBottom: `1px solid ${T.n100}`, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <button onClick={() => navigate(-1)} style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "none", border: "none", cursor: "pointer",
          color: T.n400, fontSize: 13, fontFamily: T.sans, padding: 0,
        }}
          onMouseEnter={e => e.currentTarget.style.color = T.n800}
          onMouseLeave={e => e.currentTarget.style.color = T.n400}>
          <Icon name="ArrowLeft" size={14} strokeWidth={2} />
          Back
        </button>
        <a href="mailto:sales@jiraniapp.com" style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "none", border: `1px solid ${T.n200}`,
          color: T.n600, fontSize: 13, fontFamily: T.sans,
          padding: "8px 16px", borderRadius: 8, fontWeight: 500,
          textDecoration: "none",
        }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = T.n400; e.currentTarget.style.color = T.n900; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = T.n200; e.currentTarget.style.color = T.n600; }}>
          <Icon name="Mail" size={13} strokeWidth={2} />
          sales@jiraniapp.com
        </a>
      </div>

      {/* ══ HERO ══ */}
      <div style={{ padding: "clamp(52px,7vw,88px) 20px clamp(44px,5vw,64px)", borderBottom: `1px solid ${T.n100}` }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, color: T.g600, fontSize: 12, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 22 }}>
            <Icon name="MessageCircle" size={14} color={T.g500} strokeWidth={2.2} />
            Contact sales
          </div>
          <h1 style={{ fontFamily: T.serif, fontSize: "clamp(38px,7vw,66px)", fontWeight: 400, margin: "0 0 20px", lineHeight: 1.06, color: T.n900, letterSpacing: "-0.03em", maxWidth: 600 }}>
            We are here.<br />
            <em style={{ fontStyle: "italic", color: T.g600 }}>Talk to us.</em>
          </h1>
          <p style={{ fontSize: "clamp(15px,2vw,17px)", color: T.n600, lineHeight: 1.8, margin: "0 0 36px", maxWidth: 500 }}>
            Whether you are a homeowner booking your first service, a business looking to scale, or a professional ready to join the platform, we have a team ready to help you move quickly.
          </p>

          {/* ── Audience selector ── */}
          <div style={{ marginBottom: 4 }}>
            <p style={{ fontSize: 13, fontWeight: 600, color: T.n600, margin: "0 0 12px", letterSpacing: "-0.01em" }}>
              Who are you?
            </p>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              {AUDIENCE_OPTIONS.map(opt => {
                const active = audience === opt.id;
                return (
                  <button key={opt.id} onClick={() => setAudience(opt.id)} style={{
                    display: "inline-flex", alignItems: "center", gap: 10,
                    padding: "12px 18px", borderRadius: 12,
                    border: `1.5px solid ${active ? opt.color : T.n150}`,
                    background: active ? opt.colorBg : T.white,
                    cursor: "pointer", fontFamily: T.sans,
                    transition: "all .2s", textAlign: "left",
                  }}>
                    <div style={{
                      width: 34, height: 34, borderRadius: 9, flexShrink: 0,
                      background: active ? opt.colorBg : T.n50,
                      border: `1px solid ${active ? opt.colorBorder : T.n150}`,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      transition: "all .2s",
                    }}>
                      <Icon name={opt.icon} size={15} color={active ? opt.color : T.n400} strokeWidth={1.7} />
                    </div>
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 600, color: active ? T.n900 : T.n700, lineHeight: 1.2, marginBottom: 2 }}>{opt.label}</div>
                      <div style={{ fontSize: 11, color: active ? T.n500 || T.n600 : T.n400, lineHeight: 1.3 }}>{opt.sub}</div>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* ══ CONTACT CHANNELS STRIP ══ */}
      <div style={{ borderBottom: `1px solid ${T.n100}`, padding: "0 20px" }}>
        <div style={{ maxWidth: 720, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))" }}>
          {[
            { icon: "Mail",  label: "Email", value: "sales@jiraniapp.com", sub: "Response within one business day", href: "mailto:sales@jiraniapp.com" },
            { icon: "Phone", label: "Phone", value: "+254 700 000 000",     sub: "Mon to Fri, 8am to 6pm EAT",      href: "tel:+254700000000" },
            { icon: "Clock", label: "Response time", value: "Within 24 hours", sub: "On business days", href: null },
          ].map(({ icon, label, value, sub, href }, i) => {
            const inner = (
              <div key={i} style={{
                padding: "20px",
                display: "flex", alignItems: "center", gap: 12,
                borderRight: i < 2 ? `1px solid ${T.n100}` : "none",
              }}>
                <Icon name={icon} size={17} color={T.g500} strokeWidth={1.5} />
                <div>
                  <div style={{ fontSize: 11, fontWeight: 600, color: T.n400, letterSpacing: "0.05em", textTransform: "uppercase", marginBottom: 2 }}>{label}</div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: T.n800 }}>{value}</div>
                  <div style={{ fontSize: 11, color: T.n400 }}>{sub}</div>
                </div>
              </div>
            );
            return href
              ? <a key={i} href={href} style={{ textDecoration: "none" }}>{inner}</a>
              : <div key={i}>{inner}</div>;
          })}
        </div>
      </div>

      {/* ══ MAIN CONTENT ══ */}
      <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 20px" }}>

        <div style={{ paddingTop: "clamp(44px,6vw,64px)", display: "grid", gridTemplateColumns: "1fr", gap: "clamp(40px,6vw,56px)" }}>

          {/* ── Form ── */}
          <SalesForm audience={audience} />

          {/* ── Reasons panel ── */}
          <div style={{ padding: "clamp(24px,4vw,36px)", borderRadius: 20, background: T.g50, border: `1px solid ${T.g100}` }}>
            <div style={{ display: "inline-flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
              <div style={{
                width: 34, height: 34, borderRadius: 9,
                background: T.white, border: `1.5px solid ${T.g100}`,
                display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                <Icon name={selected.icon} size={15} color={T.g500} strokeWidth={1.7} />
              </div>
              <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: 0 }}>
                {ctx.reasonsTitle}
              </p>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 14 }}>
              {ctx.reasons.map((r, i) => <ReasonItem key={i} {...r} />)}
            </div>
          </div>

          {/* ── Offices / reach ── */}
          <div style={{ marginBottom: "clamp(8px,3vw,24px)" }}>
            <p style={{ fontSize: 11, fontWeight: 600, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>Our reach</p>
            <h2 style={{ fontFamily: T.serif, fontSize: "clamp(24px,4vw,32px)", fontWeight: 400, color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.2 }}>
              Active across <em style={{ fontStyle: "italic", color: T.g600 }}>Kenya</em>
            </h2>
            <p style={{ fontSize: 15, color: T.n400, margin: "0 0 24px", lineHeight: 1.65 }}>
              JiraniApp is not Nairobi-only. Our professionals operate across six counties and counting. If you are outside these areas and need coverage, mention it in your message and we will let you know where things stand.
            </p>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 10 }}>
              {[
                { city: "Nairobi",  note: "Full coverage, all services" },
                { city: "Mombasa",  note: "Full coverage, all services" },
                { city: "Kisumu",   note: "Full coverage, all services" },
                { city: "Nakuru",   note: "Core services available" },
                { city: "Eldoret",  note: "Core services available" },
                { city: "Expanding", note: "New cities added regularly" },
              ].map(({ city, note }, i) => (
                <div key={i} style={{
                  padding: "16px 18px", borderRadius: 12,
                  border: `1px solid ${city === "Expanding" ? T.amberBorder : T.n150}`,
                  background: city === "Expanding" ? T.amberBg : T.n50,
                }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 5 }}>
                    <Icon name="MapPin" size={13} color={city === "Expanding" ? T.amber : T.g500} strokeWidth={2} />
                    <span style={{ fontSize: 13, fontWeight: 600, color: city === "Expanding" ? T.amber : T.n900 }}>{city}</span>
                  </div>
                  <span style={{ fontSize: 11, color: city === "Expanding" ? "#92400e" : T.n400, lineHeight: 1.4 }}>{note}</span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}